import { useMutation } from "@tanstack/react-query"
import { getDomain } from "utils/domain"

interface CreateCheckoutSessionParams {
  orderId: string
  regUuid: string
  deviceId: string
}

export const useCreateCheckoutSessionMutation = () => {
  return useMutation({
    mutationFn: async ({ orderId, regUuid, deviceId }: CreateCheckoutSessionParams) => {
      const response = await fetch(
        `${getDomain()}api/registration/order/${orderId}/create-checkout-session/?reg_uuid=${regUuid}&device_id=${deviceId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      if (!response.ok) {
        throw new Error("Failed to fetch checkout session")
      }

      return response.json()
    },
  })
}